var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    { attrs: { placement: "left" }, on: { show: _vm.handleShow } },
    [
      _c(
        "el-select",
        {
          attrs: { placeholder: "请选择" },
          model: {
            value: _vm.baseUrl,
            callback: function($$v) {
              _vm.baseUrl = $$v
            },
            expression: "baseUrl"
          }
        },
        _vm._l(_vm.apiList, function(item, index) {
          return _c("el-option", {
            key: index,
            attrs: { label: item.name + "-" + item.url, value: item.url }
          })
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "el-radio-group",
        {
          staticClass: "store-select-radio",
          model: {
            value: _vm.store,
            callback: function($$v) {
              _vm.store = $$v
            },
            expression: "store"
          }
        },
        [
          _c("el-radio", { attrs: { label: "dev" } }, [_vm._v("dev库")]),
          _vm._v(" "),
          _c("el-radio", { attrs: { label: "uat" } }, [_vm._v("uat库")])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-button",
        {
          attrs: { size: "small", type: "primary" },
          on: { click: _vm.submitApiChange }
        },
        [_vm._v("切换")]
      ),
      _vm._v(" "),
      _vm.isDev
        ? _c(
            "div",
            {
              directives: [{ name: "drag", rawName: "v-drag" }],
              attrs: { slot: "reference", id: "api-btn" },
              slot: "reference"
            },
            [_vm._v("切换接口")]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-90f76694", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-90f76694","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ApiSelect.vue
// module id = null
// module chunks = 